module.exports = __webpack_public_path__ + "static/media/ordened-desc-icon.007dca07.svg";